var _stop, _stop2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
var SvgOutline = function SvgOutline(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "75.329%",
    y1: "30.961%",
    x2: "0%",
    y2: "77.523%",
    id: _id
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C66FF",
    offset: "0%"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37F",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M0 0h20v20H0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4 14.25a.75.75 0 01.102 1.493L4 15.75H3a.75.75 0 01-.102-1.493L3 14.25h1zm13 0a.75.75 0 01.102 1.493L17 15.75H8a.75.75 0 01-.102-1.493L8 14.25h9zm-10-5a.75.75 0 01.102 1.493L7 10.75H6a.75.75 0 01-.102-1.493L6 9.25h1zm10 0a.75.75 0 01.102 1.493L17 10.75h-6a.75.75 0 01-.102-1.493L11 9.25h6zm0-5a.75.75 0 01.102 1.493L17 5.75H8a.75.75 0 01-.102-1.493L8 4.25h9zm-13 0a.75.75 0 01.102 1.493L4 5.75H3a.75.75 0 01-.102-1.493L3 4.25h1z",
    fill: "url(#".concat(_id, ")")
  })));
};
export default SvgOutline;